import {Typography} from '../../../../../atoms/Typography';
import {Link} from '../../../../../atoms/Link';
import './ExploreSection.sass';

export const ExploreSection = ({subCategories}) => {
  const exploreSection = subCategories?.find((subCategory) =>
    subCategory?.name?.includes('explore_')
  );

  if (!exploreSection) return null;

  return (
    <div className="explore-section">
      <Typography variant="label2" color="coin" className="explore-section__title">
        {exploreSection.display_name}
      </Typography>

      {exploreSection.categories.map((subCategory) => (
        <Link
          key={subCategory.name}
          href={subCategory.href}
          data-qa-id={subCategory.dataQaId}
          variant="large"
          className="explore-section__link"
        >
          <Typography variant="header5" color="charcoal">
            {subCategory.display_name}
          </Typography>
        </Link>
      ))}
    </div>
  );
};
